<template>
	<section class="promotions main-content align-left">
		<div class="row row-header align-left">
			<h2 v-if="subtitle" class="subtitle">{{ subtitle }}</h2>
			<div class="columns column12">
				<h2>{{ header }}</h2>
				<nuxt-link v-if="moreButtonLabel" class="button button-no-fill" :to="localePath('meetingform')">
					{{ moreButtonLabel }}
				</nuxt-link>
			</div>
		</div>
		<block-overview :packages="promoblocks" :amount="4" />
	</section>
</template>

<script setup>
const localePath = useLocalePath();

defineProps({
	subtitle: { type: String, default: '' },
	promoblocks: { type: Array, default: () => [] },
	amount: { type: Number, default: 3 },
	header: { type: String, default: '' },
	moreButtonLabel: { type: String, default: '' },
});
</script>

<style lang="scss" scoped>
.row-header {
	max-width: 1680px;
	padding: 0 16px;
}

.columns {
	padding: 0;
	display: flex;
	justify-content: space-between;
}

.button {
	align-self: center;
	margin: 0;
}

.promotions {
	.columns {
		h2 {
			padding-right: 10px;
			max-width: 70%;
		}
	}
}

@media (max-width: 550px) {
	.promotions {
		.columns {
			flex-flow: column;

			.button-no-fill,
			h2 {
				width: 100%;
			}
		}
	}
}
</style>
